const swea = require('swea');
const DepthInteraction = swea.editor.interactions.DepthInteraction;
const InstructionServiceActions = swea.react.actions.InstructionServiceActions;
const ViewerManager = swea.editor.ViewerManager;
const InteractionManager = swea.editor.InteractionManager;


class CustomDepthInteraction extends DepthInteraction {
  /**
   * The constructor.
   * @param { object } options An option object, see {@link DepthInteraction} for more info.
   */
  constructor(options) {
    super(options);
    this._disabledInteractionClasses = [];
  }
  
  /**
   * Initializes the interaction.
   * @param element the element that the interaction listens to.
   * @param viewerId the viewer id of the viewer the interaction operates in.
   */
  initialize(element, viewerId){
    super.initialize(element, viewerId);

    // When user closes the tool
    this.addTrigger(new swea.editor.interactions.EventHandler(
      [swea.editor.interactions.eventCodes.ESC],
      this,
      () => {
        this.terminate();
      }
    ));
  }

  /**
   * When the interaction is initialized open the correct context menu.
   * @param element { DOMElement } The element that the interaction works on
   * @param viewerId { number } The ID of the viewer.
   * @override
   */
  whenInitialized(element, viewerId){
    super.whenInitialized(element, viewerId);

    InstructionServiceActions.showInstruction('instructions.near_depth_position');
    ViewerManager.instance().getViewerById(viewerId).setCursor('crosshair');
    this._disabledInteractionClasses = InteractionManager.instance().disableContinuousInteractions();
  }

  /**
   * Called when near position has been indicated.
   * @param { number } viewerId The ID of the viewer.
   * @private
   * @override
   */
  _whenNearIndicated(viewerId) {
    viewerId;
    InstructionServiceActions.showInstruction('instructions.far_depth_position');
  }
  
  /**
   * Called when indicating.
   * @private
   * @override
   */
  _whenFailed() {
    InstructionServiceActions.showInstruction('instructions.failed_depth_position');
  }
  
  whenTerminated(element, viewerId){
    super.whenTerminated(element, viewerId);
    ViewerManager.instance().getViewerById(viewerId).setCursor('default');
    InteractionManager.instance().enableContinuousInteractions(this._disabledInteractionClasses);
    InstructionServiceActions.hideInstruction();
  }
}
export default CustomDepthInteraction;
